import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SplitscreenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"splitscreen"}/>
}
